import { render } from "./YoutubeLayer.vue?vue&type=template&id=b3a30ad2&lang=pug"
import script from "./YoutubeLayer.vue?vue&type=script&lang=js"
export * from "./YoutubeLayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__